import React from 'react';

import { ColumnLayout } from '@jpmuitk/column-layout';

export default ({ children, spacing = 5, style }) => (
  <ColumnLayout container spacing={spacing} style={style}>
    {children}
  </ColumnLayout>
);
